import {Badge} from "react-bootstrap";
import React from "react";

export function SecondaryOutlineBadge(props) {
    return <Badge className={`outline-secondary font-max ${props.className}`}>{props.children}</Badge>
}
